import { render, staticRenderFns } from "./RideOffers.vue?vue&type=template&id=12056329"
import script from "./RideOffers.vue?vue&type=script&lang=js"
export * from "./RideOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports